import React, { useState, useEffect } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { FaPen } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useUserInfor, updateUser } from "../../hooks/api/useAuth";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

function RightSideAccountSetting() {
  const { data: user, isLoading, error:inforError } = useUserInfor();

  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [contactInfo, setContactInfo] = useState("");

  // Update user mutation
  const {error, isSuccess:updateSuccess, isPending,  mutate:updateMe } = useMutation({
    mutationFn: updateUser,
  });
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Extract only the date portion
  };

  useEffect(() => {
    const user_ = user?.data?.user? user?.data?.user: null;
    console.log();
    if (user_) {
      setName(user_.name || "");
      setDob(user_.date_of_birth ? formatDate(user_.date_of_birth) : "");
      setContactInfo(user_?.contact || "");
      setGender(user_?.gender || "");
    }
  }, [user]);

  useEffect(() => {
    
    if (updateSuccess) {
      toast.success("Update Successfully");
    }
    if (error) {
      toast.error("Update Failed");
    }
  }, [updateSuccess, error]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      name,
      dob: dob,
      contact: contactInfo,
      gender:gender
    };

    updateMe(data);
  };

  return (
    <div className="sm:mt-14 bg-white sm:pb-10 dark:bg-[#181818] mt-10 sm:shadow-md sm:hover:shadow-lg m-2 sm:ml-0 sm:w-[900px] h-full items-center rounded-[25px]">
      <div className="border sm:h-[90px] rounded-[25px] h-[120px] grid place-content-center w-full bg-gradient-to-b items-center from-[#D62723] to-[#2A71E8]">
        <div className="flex absolute space-x-[120px] mb-14 sm:hidden">
          <Link to="/settings/profile">
            <BsArrowLeft
              size={24}
              color="white"
              className="cursor-pointer ml-2"
            />
          </Link>
          <h3 className="text-white dark:text-white font-[10px] font-sans ml-[10px]">
            Edit Profile
          </h3>
        </div>
        <div className="items-center">
          <div className="bg-white rounded-full w-full h-full sm:mt-4 mt-[100px] border relative border-gray-400">
            <img
              src={require("../../assets/img/profile.png")}
              alt=""
              className="px-2 py-2"
            />
            <div className="bg-[#D2D2D6] rounded-full w-[25px] h-[25px] absolute ml-10 bottom-0.5">
              <FaPen className="m-2 w-3 grid place-content-center h-3" />
            </div>
          </div>
        </div>
      </div>
      {isLoading &&<div className="flex w-full items-center justify-center mt-2"> <l-tail-chase size="25" speed="1.75" color="black"></l-tail-chase> </div>}
      {inforError &&<div className="flex w-full items-center justify-center mt-2 text-red-500 text-center text-sm"> Failed to load user information </div>}

      <h3 className="font-bold mt-10 grid place-content-center text-[20px] sm:hidden dark:text-white">
        {name || ""}
      </h3>
      <form >
        <div className="sm:mt-5 mt-4 grid place-content-center sm:space-y-3 space-y-7 h-full">
          <div>
            <label className="dark:text-white font-sans">Name</label>
            <div className="border h-[30.42px] rounded-[25px] dark:bg-gray-800 border-black flex items-center relative">
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="outline-none ml-2 w-[250px] sm:w-[320px] bg-white dark:bg-gray-800 dark:text-white px-3"
              />
            </div>
          </div>
          <div>
            <label className="dark:text-white font-sans">BirthDate</label>
            <div className="border h-[30.42px] rounded-[25px] dark:bg-gray-800 flex items-center border-black relative">
              <input
                type="date"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
                className="outline-none ml-2 w-[300px] sm:w-[320px] bg-white dark:bg-gray-800 dark:text-white"
              />
            </div>
          </div>

          <div>
            <label className="font-sans dark:text-white">Gender</label>
            <div className="border h-[30.42px] rounded-[25px] flex dark:bg-gray-800 items-center border-black relative">
              <select
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                className="outline-none ml-2 w-[200px] sm:w-[320px] bg-white dark:bg-gray-800 dark:text-white px-3"
              >
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
                <option value="Prefer not to say">Prefer not to say</option>
              </select>
            </div>
          </div>

          <div>
            <label className="font-sans dark:text-white">Contact Info</label>
            <div className="border h-[30.42px] rounded-[25px] dark:bg-gray-800  border-black flex items-center relative">
              <input
                type="text"
                value={contactInfo}
                onChange={(e) => setContactInfo(e.target.value)}
                className="outline-none ml-2 w-[200px] sm:w-[320px] bg-white dark:bg-gray-800 dark:text-white px-3"
              />
            </div>
          </div>

          <button onClick={(e)=>{handleSubmit(e)}} className="bg-[#0049F5] rounded-[25px] sm:w-[247px] dark:text-white w-full h-[50.42px] sm:m-11 mt-10 text-[24px] font-sans sm:h-[36px] text-white px-10">
            {isPending ? <l-tail-chase size="25" speed="1.75" color="black"></l-tail-chase> : "Save"}
          </button>

        </div>
      </form>
    </div>
  );
}

export default RightSideAccountSetting;
